import { Button, Flex, Layout } from "antd";
import EmployeeSalaryAllowanceComponents from "../components/EmployeeSalaryAllowance";
import useEmployeeSalaryAllowance from "../hooks/useEmployeeSalaryAllowance";
import { Content, Footer } from "antd/lib/layout/layout";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

function EmployeeSalaryAllowance() {
  const employeeSalaryAllowanceProps = useEmployeeSalaryAllowance();
  const { refButton } = employeeSalaryAllowanceProps;
  const { t } = useTranslation();


  return (
    <Layout>
      <Content>
        <EmployeeSalaryAllowanceComponents {...employeeSalaryAllowanceProps} refButton={refButton} />
      </Content>
      <Footer style={{
        // ...dataForSave.length === 0 ? { display: 'none' } : {},
        backgroundColor: 'white',
        position: 'sticky',
        bottom: '0px',
        height: '10vh',
        zIndex: 990
      }}>
        <Flex justify="end" gap={20}>
          <Button size="large" type="default"
            onClick={() => {
              employeeSalaryAllowanceProps?.onClear()
              // console.log("refButton.current", refButton?.current?.resetForm());
            }}>
            {t('allowance.clear')}
          </Button>
          <Button size="large" type="primary" style={{ backgroundColor: "var(--button-color)" }}
            onClick={() => {
              refButton?.current?.submitForm()
            }}>{t('allowance.submit')}
          </Button>
        </Flex>
      </Footer>
    </Layout>
  );
}

export default EmployeeSalaryAllowance;
